export const PH_FEATURE_FLAG_CLOAKED_PAY_ENABLE_SUBSCRIPTION =
  "cloaked_pay_enable_subscription";

export const PH_VIRTUAL_CARDS_FEATURE_FLAG_SUMMARY_VIEW_DETAILS =
  "cloaked_pay_summary_view_details";
